import useSWRImmutable from 'swr/immutable'
import { getFees } from '../api/fees'
import { Fees } from '@cinch-labs/logistics-fees-types'

export interface FeesResponse {
  data?: Fees
  isLoading: boolean
  error?: Error
}

export const useFees = (): FeesResponse => {
  const { data, error, isLoading } = useSWRImmutable<Fees, Error>(
    'fees',
    getFees,
    { errorRetryCount: 1 },
  )

  return { data, isLoading, error }
}
